import { ReactNode } from 'react';
import { EditCellBase } from './EditCellBase';
import { Checkbox } from './Checkbox';
import styled from 'styled-components';

const StyledCheckboxContainer = styled.div`
	width: 100%;
	height: 100%;
	flex: 1;

	display: flex;
	justify-content: center;
	align-items: center;

	background: ${({ theme }) => theme.input_bg};
	border-bottom: 2px solid ${({ theme }) => theme.text_theme};
`;

export function EditCellCheckbox({
	children,
	value,
	saveValues,
	disabled,
}: {
	children: ReactNode;
	value: boolean | null;
	saveValues: (select: boolean | null) => Promise<void>;
	disabled?: boolean;
}) {
	return (
		<EditCellBase
			minWidth="50px"
			value={value}
			saveValues={saveValues}
			disabled={disabled}
			renderEditor={({ value: valueRender, onChange: onChangeRender, saving }) => (
				<StyledCheckboxContainer>
					<Checkbox value={valueRender} onChange={onChangeRender} disabled={saving} />
				</StyledCheckboxContainer>
			)}
		>
			{children}
		</EditCellBase>
	);
}
